<template>
  <div>
    <!-- 面包屑 -->
    <breadcrumbs></breadcrumbs>
    <!-- 表单查询 -->
    <div class="bg-white pd-5">
      <el-form :inline="true" ref="form" :model="form" label-width="100px">
        <el-form-item label="水卡编号">
          <el-input
            v-model="form.cardId"
            clearable
            placeholder="请输入水卡编号"
          ></el-input>
        </el-form-item>

        <el-form-item label="添加时间">
          <el-date-picker
            v-model="form.startTime"
            format="yyyy-MM-dd"
            type="date"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
          至
          <el-date-picker
            v-model="form.endTime"
            :picker-options="pickerOptionsEnd"
            format="yyyy-MM-dd"
            type="date"
            placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getList()">查询</el-button>
          <el-button
            @click="
              form = { startTime: '', endTime: '' };
              getList();
            "
            >重置</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <btns class="mgb-20" @exec="exec"></btns>
    <div class="mgb-20 flex aic">
      <div>水卡总数：{{ total }}</div>
      <div class="mgl-15 colorred">
        温馨提示：添加水卡白名单后，可以在企业内全部设备上使用，请谨慎配置。
      </div>
    </div>
    <el-table :data="tableData" stripe border style="width: 100%">
      <el-table-column
        type="index"
        :index="indexMethod"
        label="序号"
        width="50"
        fixed="left"
      >
      </el-table-column>
      <el-table-column prop="cardId" label="水卡编号"> </el-table-column>
      <el-table-column prop="cardType" label="水卡类型">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.cardType == 1
                ? '电子卡'
                : scope.row.cardType == 2
                ? '实物卡'
                : '- -'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="cardStatus" label="水卡状态">
        <template slot-scope="scope">
          <span
            v-text="
              scope.row.cardStatus == 0
                ? '正常'
                : scope.row.cardStatus == 1
                ? '挂失'
                : '异常'
            "
          ></span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="添加时间"> </el-table-column>
      <el-table-column fixed="right" label="操作" width="120">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleDel(scope.row)"
            >移除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页器 -->
    <el-pagination
      class="mgt-20"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="page"
      :page-sizes="[5, 20, 30, 40, 50]"
      :page-size="pageSize"
      layout=" prev, pager, next"
      :total="total"
    >
    </el-pagination>
    <el-dialog
      title="新增水卡"
      :visible.sync="dialogVisible"
      width="30%"
      center
      top="30vh"
      :close-on-click-modal="false"
    >
      <el-form ref="addForm" :rules="rules" :model="addForm" label-width="80px">
        <el-form-item label="水卡编号" prop="num">
          <el-input
            v-model="addForm.num"
            placeholder="请输入水卡编号"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="所属企业" prop="company" v-if="addForm.company">
          <el-input v-model="addForm.company" disabled></el-input>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="mgr-30" @click="dialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="handleAdd('addForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import breadcrumbs from "@/components/breadcrumbs.vue";
import btns from "@/components/btns.vue";
import { handleConfirm, handleAlert } from "../../components/UtilsIf";
export default {
  components: {
    breadcrumbs,
    btns,
  },
  data() {
    return {
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.form.startTime;
          if (beginDateVal) {
            return (
              time.setHours(0, 0, 0, 0) <
              new Date(beginDateVal).setHours(0, 0, 0, 0)
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      form: {},
      // 分页数据
      page: 1, // 当前页，默认
      pageSize: 15, //每页显示多少条数据，默认
      total: 50, // 数据总条数
      tableData: [],
      dialogVisible: false,
      addForm: { num: "", company: "" },
      rules: {
        num: [{ required: true, message: "请输入水卡编号", trigger: "blur" }],
      },
    };
  },
  watch: {
    "form.startTime"() {
      if (this.form.startTime == null) {
        this.form.endTime = null;
      }
    },
  },
  created() {
    this.getList();
  },
  methods: {
    queryCompany() {
      if (this.addForm.num.length == 8) {
        this.$api.waterCard
          .queryCompany({ cardId: this.addForm.num })
          .then((res) => {
            if (res.code === 200) {
              this.addForm.company = res.data.companyName;
            }
          });
      }
    },
    handleDel(row) {
      handleConfirm("确认将该水卡移除白名单吗?", "info")
        .then(() => {
          this.$api.waterCard.whiteDel({ id: row.id }).then((res) => {
            if (res.code === 200) {
              handleAlert("水卡已移除白名单", "success");
              this.getList();
            }
          });
        })
        .catch(() => {
          return;
        });
    },
    add() {
      this.addForm = { num: "", company: "" };
      this.$nextTick(() => {
        //清楚表单内容
        this.$refs.addForm.clearValidate();
      });
      this.dialogVisible = true;
    },
    handleAdd(d) {
      this.$refs[d].validate((valid) => {
        if (valid) {
          handleConfirm(`确认新增该水卡${this.addForm.num}到白名单吗?`, "info")
            .then(() => {
              this.$api.waterCard
                .whiteAdd({ cardId: this.addForm.num })
                .then((res) => {
                  if (res.code === 200) {
                    handleAlert("新增成功", "success");
                    this.getList();
                    this.dialogVisible = false;
                  }
                });
            })
            .catch(() => {
              return;
            });
        } else {
          return false;
        }
      });
    },
    getList(pageNum) {
      if (!pageNum) {
        this.page = 1;
      }
      this.$api.waterCard
        .whiteList({
          cardId: this.form.cardId,
          startTime: this.form.startTime,
          endTime: this.form.endTime,
          pageNum: this.page,
          pageSize: this.pageSize,
        })
        .then((res) => {
          if (res.code === 200) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          }
        });
    },
    exec(fun) {
      if (this[fun]) {
        this.funTit = fun;
        this[fun]();
      } else {
        this.$message.error("方法未定义");
      }
    },
    //表格序号，根据索引+1
    indexMethod(index) {
      return index + 1;
    },
    // 分页事件
    // 每页显示多少条,条数改变时触发事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList(this.page);
    },
    // 当前页面,当前页面改变时触发事件
    handleCurrentChange(val) {
      this.page = val;
      this.getList(this.page);
    },
  },
};
</script>

<style lang="scss" scoped></style>
